import { useContext } from 'react';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetAvailableNationalitiesAvailableNationalitiesDto as NationalitiesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';
import { NationalitiesContext } from '../contexts/NationalitiesContext';

export const useNationalities = (): Loadable<NationalitiesDto[]> => {
  const context = useContext(NationalitiesContext);

  return context;
};
